<template>
  <div class="tbe-price-breakdown">
    <h5 class="tbe-price-breakdown__title">Price breakdown</h5>
    <ul class="tbe-price-breakdown__list tbe-price-breakdown-list">
      <li class="tbe-flex tbe-justify-content-between">
        <span>
          Participants {{ amountPeople }} × {{ currency.value }}&nbsp;{{ price.toPerson }}
        </span>
        <span>{{ currency.value }}&nbsp;{{ price.total }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  export default {
    name: 'tbePriceBreakdown',

    props: {
      amountPeople: Number,
      price: Object
    },

    setup() {
      const store = useStore()

      const currency = computed(() => store.state.app.generalSettings.currency)

      return { currency }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-price-breakdown {
    &__title {
      font-size: 16px;
      padding-bottom: 5px;
      line-height: 1;

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }
  }
  .tbe-price-breakdown-list {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      display: flex;
      align-items: center;
      height: 28px;
      border-bottom: 1px solid #dcdfe4;
      font-size: 14px;

      &:last-of-type {
        border-bottom: none;
      }

      @media screen and (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
</style>
